import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { getEndpointUrl } from '../config/api';
import {
  Box,
  Button,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GetAppIcon from '@mui/icons-material/GetApp';
import Layout from './Layout';

const RegistrosNaoProcessados = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRegistrosNaoProcessados = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');

      if (!token) {
        setError('Você precisa estar autenticado para ver esta página.');
        setLoading(false);
        return;
      }

      const response = await api.get(`/importacao/${id}/registros-nao-processados`);

      console.log('Resposta da API:', response.data);
      
      if (response.data && response.data.registros_nao_processados) {
        setRegistros(response.data.registros_nao_processados);
      } else {
        setRegistros([]);
      }
      
      setLoading(false);
    } catch (err) {
      console.error('Erro ao buscar registros não processados:', err);
      setError('Erro ao carregar os registros. Por favor, tente novamente.');
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchRegistrosNaoProcessados();
  }, [fetchRegistrosNaoProcessados]);

  const handleExportarExcel = () => {
    const token = localStorage.getItem('token');
    const url = getEndpointUrl(`/importacao/${id}/exportar-nao-processados`);
    const sep = url.includes('?') ? '&' : '?';
    window.open(`${url}${sep}token=${encodeURIComponent(token || '')}`, '_blank');
  };

  const handleVoltar = () => {
    navigate('/dashboard');
  };

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={handleVoltar} sx={{ mr: 1 }}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Registros Não Processados</Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<GetAppIcon />}
            onClick={handleExportarExcel}
          >
            Exportar para Excel
          </Button>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        ) : registros.length === 0 ? (
          <Paper sx={{ p: 4, textAlign: 'center', backgroundColor: '#f8f9fa' }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h4" sx={{ color: '#4CAF50', mb: 1 }}>
                ✅
              </Typography>
              <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
                Parabéns! Importação 100% Bem-sucedida
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Todos os registros foram processados com sucesso.<br/>
                Não há registros não processados para esta importação.
              </Typography>
            </Box>
          </Paper>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Corretora</TableCell>
                  <TableCell>Motivo</TableCell>
                  <TableCell>Seguradora</TableCell>
                  <TableCell>Data</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {registros.map((registro) => (
                  <TableRow key={registro.id}>
                    <TableCell>{registro.corretora}</TableCell>
                    <TableCell>{registro.motivo}</TableCell>
                    <TableCell>{registro.seguradora}</TableCell>
                    <TableCell>{registro.data_criacao}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Layout>
  );
};

export default RegistrosNaoProcessados; 